/* eslint-disable no-debugger */
import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  Injectable,
  OnInit,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { DOCUMENT, Location } from '@angular/common';

import MetisMenu from 'metismenujs';
import { MenuItem } from './menu.model';
import { NavigationEnd, Route, Router } from '@angular/router';
import { UserService } from "../../../_services/user.service";
import { SideNavService } from "./side-name.service";
import { StorageService } from "../../../_services/storage.service";
import { MenusService } from "../../../_services/menu.service";
import { environment } from "../../../../environments/environment";
import { AlertService } from 'src/app/_services/alert.service';
import { AuthService } from 'src/app/_services/auth.service';
import { InactivityService } from 'src/app/_helpers/inactivity-check-service';

const { level3_exclude } = environment

const routeConst = [
  {
    title: 'Merchant/Agent Master',
    path: '/merchants/reseller-master'
  },
  {
    title: 'Customer Master',
    path: '/customerMaster'
  }
]
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, AfterViewInit {

  @ViewChild('sidebarToggler') public sidebarToggler: ElementRef;

  menuItems: MenuItem[] = [];
  levelExclude = [...level3_exclude]
  menus: any[];
  mm: MetisMenu;
  activeCheck : boolean= false;
  @ViewChild('sidebarMenu') sidebarMenu: ElementRef;
  @ViewChild('menu') menuElement: any;

  @ViewChildren('menuListItem') menuListItems: QueryList<any>;
  id: any;

  constructor(@Inject(DOCUMENT) private document: Document,private inactivityService : InactivityService, private authService: AuthService, private alertService: AlertService, private location: Location, private menuService: MenusService, private renderer: Renderer2, private router: Router, private userService: UserService, storageService: StorageService, public sideNavService: SideNavService) {
    try {
      this.userService.getUserProfileNew().subscribe((data) => {
        if (this.mm) this.mm.dispose();
        const structMenu = this.menuService.structuredMenu(this.menuService.transformApiResponse(data.data));
        console.log(structMenu);
        this.menuService.saveMenusItems(structMenu);
        const { finalMenus, sidebarMenus } = structMenu;
        // if (structMenu.finalMenus[0].ROLENAME == "Reseller" || structMenu.finalMenus[0].ROLENAME == "Merchant") {
        //   if (structMenu.finalMenus[0].ROLENAME == "Reseller" ) {
        //   this.alertService.errorAlert({
        //     title: "No Access! Contact Administrator",
        //     backdrop: true,
        //     toast: true,
        //     timer: 2000, position: 'top-end'
        //   })
        //   this.inactivityService.stopInactivityTracking();
        //   this.authService.logout('unauthorized');  // Unauthorized access - reseller role


        // }
        console.log(sidebarMenus)
        sidebarMenus.forEach((m: any) => {
          this.menuItems.push({
            ...m,
            label: m.title || m.label,
            isTitle: true
          });
          this.menuItems.push(m);
        })

        router.events.forEach((event) => {
          if (event instanceof NavigationEnd) {

            /**
             * Activating the current active item dropdown : Radhe
             */
            this._activateMenuDropdown();

            /**
             * closing the sidebar : Radhe
             */
            if (window.matchMedia('(max-width: 991px)').matches) {
              this.document.body.classList.remove('sidebar-open');
            }

          }
        });
        this._activateMenuDropdown();
        this.onSidebarThemeChange('')
        /**
         * Sidebar-folded on desktop (min-width:992px and max-width: 1199px)
         */
        const desktopMedium = window.matchMedia('(min-width:992px) and (max-width: 1199px)');
        desktopMedium.addEventListener('change', () => {
          this.iconSidebar;
        });
        this.iconSidebar(desktopMedium);
      })
    } catch (err) {

      router.navigate(['/auth/login'], {});
    }


  }

  ngOnInit(): void {

    console.log(this.menuItems)
    this.printpath('', this.router.config);
    this.sideNavService.sideNavToggleSubject.subscribe(() => {
      let event = new MouseEvent('click', { bubbles: true });
    });
    this.sideNavService.toggelEvent$.subscribe(($event) => {
      let event = new MouseEvent('click', { bubbles: true });
    });
    this._activateMenuDropdown();
  }

  printpath(parent: String, config: Route[]) {
    for (let i = 0; i < config.length; i++) {
      const route = config[i];
      if (route.children) {
        const currentPath = route.path ? parent + '/' + route.path : parent;
        this.printpath(currentPath, route.children);
      }
    }
  }

  ngAfterViewInit() {
    this.menuListItems.changes.subscribe(t => {
      // if(this.mm) this.mm.update();
      this.mm = new MetisMenu(this.sidebarMenu.nativeElement);
    });
  }

  /**
   * Toggle sidebar on hamburger button click
   */
  toggleSidebar(e: Event) {
    console.log("-------toggleSidebar call");
    this.sidebarToggler.nativeElement.classList.toggle('active');
    this.sidebarToggler.nativeElement.classList.toggle('not-active');
    if (window.matchMedia('(min-width: 992px)').matches) {
      e.preventDefault();
      this.document.body.classList.toggle('sidebar-folded');
    } else if (window.matchMedia('(max-width: 991px)').matches) {
      e.preventDefault();
      this.document.body.classList.toggle('sidebar-open');
    }
  }


  /**
   * Toggle settings-sidebar
   */
  toggleSettingsSidebar(e: Event) {
    e.preventDefault();
    this.document.body.classList.toggle('settings-open');
  }


  /**
   * Open sidebar when hover (in folded folded state)
   */
  operSidebarFolded() {
    if (this.document.body.classList.contains('sidebar-folded')) {
      this.document.body.classList.add("open-sidebar-folded");
    }
  }


  /**
   * Fold sidebar after mouse leave (in folded state)
   */
  closeSidebarFolded() {
    if (this.document.body.classList.contains('sidebar-folded')) {
      this.document.body.classList.remove("open-sidebar-folded");
    }
  }

  /**
   * Sidebar-folded on desktop (min-width:992px and max-width: 1199px)
   */
  iconSidebar(mq: MediaQueryList) {
    if (mq.matches) {
      this.document.body.classList.add('sidebar-folded');
    } else {
      this.document.body.classList.remove('sidebar-folded');
    }
  }


  /**
   * Switching sidebar light/dark
   */
  onSidebarThemeChange(event: any) {

    this.document.body.classList.remove('sidebar-dark', 'sidebar-light');
    this.document.body.classList.add("sidebar-dark");
    console.log((<HTMLInputElement>event.target)?.value)
    this.document.body.classList.remove('settings-open');
  }


  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }


  /**
   * Reset the menus then hilight current active menu item
   */
  _activateMenuDropdown() {
    this.resetMenuItems();
  //  this.activateMenuItems();
  }


  /**
   * Resets the menus
   */
  resetMenuItems() {


    const links = document.getElementsByClassName('nav-link-ref');

    for (let i = 0; i < links.length; i++) {
      const menuItemEl = links[i];
      menuItemEl.classList.remove('mm-active');
      const parentEl = menuItemEl.parentElement;

      if (parentEl) {
        parentEl.classList.remove('mm-active');
        const parent2El = parentEl.parentElement;

        if (parent2El) {
          parent2El.classList.remove('mm-show');
        }

        const parent3El = parent2El?.parentElement;
        if (parent3El) {
          parent3El.classList.remove('mm-active');

          if (parent3El.classList.contains('side-nav-item')) {
            const firstAnchor = parent3El.querySelector('.side-nav-link-a-ref');

            if (firstAnchor) {
              firstAnchor.classList.remove('mm-active');
            }
          }

          const parent4El = parent3El.parentElement;
          if (parent4El) {
            parent4El.classList.remove('mm-show');

            const parent5El = parent4El.parentElement;
            if (parent5El) {
              parent5El.classList.remove('mm-active');
            }
          }
        }
      }
    }
  };


  /**
   * Toggles the menu items
   */
  activateMenuItems() {
    debugger;
    const links: any = document.getElementsByClassName('nav-link-ref');
    const path = this.location.path(false);

    let menuItemEl = null;

    for (let i = 0; i < links.length; i++) {
      const linkPath = links[i]['href'].slice(links[i]['href'].indexOf('#') + 1)
      if (path === linkPath) {
        menuItemEl = links[i];
        break;
      }
    }

    if (menuItemEl) {
      debugger;
      menuItemEl.classList.add('mm-active');
      const parentEl = menuItemEl.parentElement;
      if (parentEl) {
        parentEl.classList.add('mm-active');

        const parent2El = parentEl.parentElement;
        if (parent2El) {
          parent2El.classList.add('mm-show');
        }

        const parent3El = parent2El.parentElement;
        if (parent3El) {
          parent3El.classList.add('mm-active');

          if (parent3El.classList.contains('side-nav-item')) {
            const firstAnchor = parent3El.querySelector('.side-nav-link-a-ref');

            if (firstAnchor) {
              firstAnchor.classList.add('mm-active');
            }
          }

          const parent4El = parent3El.parentElement;
          if (parent4El) {
            parent4El.classList.add('mm-show');

            const parent5El = parent4El.parentElement;
            if (parent5El) {
              parent5El.classList.add('mm-active');
            }
          }
        }
      }
    }
  }


  showSubmenu(itemEl: HTMLElement) {
    itemEl.classList.toggle("showMenu");
  }

  isOpen(event: any, i: any) {
    // if (document.querySelector(`#${i}`+'a.active') !== null) {
    //   document.querySelector(`#${i}`+'a.active')?.classList.remove('mm-active');
    // }
    // console.log("Clicked Menu 1");
    console.log(event);
    if(!this.activeCheck){
      event.currentTarget.classList.remove('mm-active');
      this.activeCheck = true;
      console.log(this.activeCheck);
    }
    if (event.currentTarget.classList[1] == 'mm-active') {
      console.log("Clicked Menu 2");
      event.currentTarget.classList.remove('mm-active');
      if (event.currentTarget.childNodes != null) {
        console.log("Clicked Menu 3");
        event.currentTarget.childNodes[3]?.classList.remove('d-block');
        event.currentTarget.childNodes[3].classList.add('d-none');
      }
    }
    else {
      // console.log("Clicked Menu 4");
      console.log("Menu : "+JSON.stringify(event.currentTarget.classList[1]));
      event.currentTarget.classList.add('mm-active');
      if (event.currentTarget.childNodes != null) {
        console.log("Clicked Menu 5");
        console.log("Event : "+event.currentTarget.childNodes[3].classList);
        event.currentTarget.childNodes[3].classList.remove('d-none');
        event.currentTarget.childNodes[3].classList.add('d-block');
        event.currentTarget.childNodes[3].style.height = '';
        event.currentTarget.childNodes[3].classList.add('mm-active');

      }
    }

  }
  isOpenSubMenu(i: any, j: any,event:any) {
  const aa=  document.getElementById('10');
  if(aa !=null){
    aa.classList.remove('mm-active');
  }
    event.currentTarget.classList.add('mm-active');
  }

  linkUrl(subitem:any){
    if(subitem=="/merchants/merchantReport"){
     window.open('../../../../assets/images/Merchant Report3.pdf','_blank')

    }
  }

  // openUrl(){
  //   window.location.href='https://www.pay10.com/plugin.php';
  // }
  openUrl(ele:any){

     if(ele.includes('crm/jsp/home')){
      debugger
      let a = document.createElement('a');
      a.target="_blank";
      a.href=ele;
      a.click();
     }
  }

  isValidUrl(link :string) {
    try {
      new URL(link);
      return true;
    } catch (err) {
      return false;
    }
  }

}
